export const ONE_DIMENSION = JSON.parse(`
  {
    "schema": "a_schema",
    "cube": [
      "entity"
    ],
    "timezone": "UTC",
    "limit": 1000,
    "slices": [
      {
        "slice": {
          "entity": "ENTITY1"
        },
        "data": {
          "entity": {
            "entity": "Some Entity",
            "created": "20150124",
            "third_party_names": {
              "dcm": "DCM Entity"
            }
          }
        }
      },
      {
        "slice": {
          "entity": "ENTITY2"
        },
        "data": {
          "entity": {
            "created": "20161230"
          }
        }
      }
    ]
  }
`)

export const SLICES_RESULTS_MULTIPLE_DIMENSIONS = JSON.parse(`
  {
    "schema": "a_schema",
    "cube": [
      "entity",
      "service"
    ],
    "timezone": "UTC",
    "slices": [
      {
        "slice": {
          "entity": "ENTITY1",
          "service": "SERVICE1"
        },
        "data": {
          "entity": {
            "entity": "Some Entity"
          },
          "service": {
            "service": "Some Service"
          }
        }
      },
      {
        "slice": {
          "entity": "ENTITY1",
          "service": "SERVICE2"
        },
        "data": {
          "entity": {
            "entity": "Some Entity"
          },
          "service": {
            "service": "Another Service"
          }
        }
      }
    ]
  }
`)
